import { useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import HowItWorks from './components/HowItWorks';
import Features from './components/Features';
import Pillars from './components/Pillars';
import Rewards from './components/Rewards';
import Testimonials from './components/Testimonials';
import Shop from './components/Shop';
import EvoSong from './components/EvoSong';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Activate scroll-reveal animations (progressive enhancement)
    document.body.classList.add('js-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('section-in');
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      { threshold: 0.07, rootMargin: '0px 0px -60px 0px' }
    );

    document.querySelectorAll('section').forEach((el) => observer.observe(el));

    // Count-up animation for [data-countup] elements
    const countUpEls = document.querySelectorAll('[data-countup]');
    const countUpObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const target = parseFloat(el.dataset.countup);
          const decimal = parseInt(el.dataset.decimal || '0', 10);
          const suffix = el.dataset.suffix || '';
          const duration = 1400;
          const startTime = performance.now();
          const tick = (now) => {
            const elapsed = Math.min(now - startTime, duration);
            const progress = 1 - Math.pow(1 - elapsed / duration, 3); // ease-out cubic
            const value = target * progress;
            el.textContent =
              (decimal > 0
                ? value.toFixed(decimal).replace('.', ',')
                : Math.round(value)) + suffix;
            if (elapsed < duration) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
          countUpObserver.unobserve(el);
        });
      },
      { threshold: 0.7 }
    );
    countUpEls.forEach((el) => countUpObserver.observe(el));

    // HowItWorks steps: stagger delays set per-card so they cascade in even when
    // all cards are in view at once (desktop), and still reveal one-by-one on mobile.
    const stepEls = document.querySelectorAll('.hiw__step-inner');
    const stepObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('step-in');
            stepObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px 100px 0px' }
    );
    stepEls.forEach((el, idx) => {
      el.style.transitionDelay = `${idx * 0.32}s`; // 0s, 0.32s, 0.64s
      stepObserver.observe(el);
    });

    // Pillar rows: slide in from alternating sides as each row enters viewport
    const rowEls = document.querySelectorAll('.pillar-row');
    const rowObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('row-in');
            rowObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px 40px 0px' }
    );
    rowEls.forEach((el) => rowObserver.observe(el));

    return () => {
      observer.disconnect();
      countUpObserver.disconnect();
      stepObserver.disconnect();
      rowObserver.disconnect();
    };
  }, []);

  return (
    <div>
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <HowItWorks />
        <Features />
        <Pillars />
        <Rewards />
        <Shop />
        <Testimonials />
        <EvoSong />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
